import { cognitionApi } from '../../services/cognitionApi';

// Assessments are the only source of a user's score. The URL prefix is distinct
// from training on purpose, so a training call cannot write to score state.
// Difficulty never adapts here, which is why submitBlock reports no stats.
export function createAssessmentDriver({ pillar, clientVersion = 'web-1.0' }) {
  let runId = null;
  let taskId = null;

  return {
    mode: 'assessment',

    // An assessment trial ends this long after an accepted response rather than
    // sitting out the rest of its window.
    //
    // This used to be null for every instrument, on the argument that trial
    // length would otherwise signal "I responded" and let a participant read the
    // rhythm instead of the stimulus. That argument is exactly right where
    // WITHHOLDING IS A RESPONSE, and exactly those instruments now carry it
    // themselves as `holdsFullWindow` — go-no-go, n-back, speed-match — which
    // this number cannot override. It was never right on the other fifteen:
    // they are forced choice, every trial ends in a response, so there is no
    // contrast for anyone to read. What it did produce there was dead time
    // proportional to how quickly the participant answered — up to fourteen
    // seconds per item on matrix-reasoning, whose window is 20000ms and which
    // is a power test where a fast correct answer is the good outcome.
    //
    // 250ms matches training, and is long enough for the selected option to
    // register visually before the screen changes.
    advanceOnResponseMs: 250,

    // Explicitly false, not merely absent. A scored trial that reveals whether
    // the response was correct lets the participant calibrate mid-run, which
    // invalidates the instrument the score is derived from. Practice trials
    // still show feedback — the runner gates that on trial.isPractice.
    feedbackOnEveryTrial: false,

    taskId: () => taskId,

    async start() {
      const res = await cognitionApi.startAssessment({ pillar, clientVersion });
      runId = res.runId;
      taskId = res.taskId;
      return { taskId, blockCount: res.blockCount, block: res.block };
    },

    async submitBlock(blockIndex, trials) {
      const res = await cognitionApi.submitAssessmentBlock({
        runId,
        taskId,
        blockIndex,
        trials,
      });
      return { nextBlock: res.nextBlock, complete: res.taskComplete, stats: null };
    },

    async finalize() {
      return cognitionApi.finalizeAssessment({ runId });
    },

    // There is no assessment abandon endpoint; an unfinalized run simply
    // never produces a score.
    async abandon() {},
  };
}
